
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./components/Home"
import Mission from "./components/Mission"
import Events from "./components/Events";
import Contact from "./components/Contact";
import About from "./components/About";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="ev" element={<Events />} />
          <Route path="mis" element={<Mission />} />
          <Route path="*" element={<Mission />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}